import * as types from "../actions/types";



const initialState = {
  list: [],
  loading: false,
  eventMembers: [],
  eventClassesWithMembers: []
};


export default function events_list(state = initialState, action) {
  switch (action.type) {

    case types.SET_EVENTS_LIST:
      return {
        ...state,
        eventsList: action.payload,
      };

    case types.SET_EVENT:
      return {
        ...state,
        eventInfo: action.payload,
      };

    case types.SET_EVENT_CLASSES:
      return {
        ...state,
        eventClasses: action.payload,
      };

    case types.SET_EVENT_MEMBERS:
      return {
        ...state,
        eventMembers: action.payload,
      };

    case types.SET_EVENT_CLASSES_WITH_MEMBERS:
      return {
        ...state,
        eventClassesWithMembers: action.payload,
      };

    // case types.SET_EVENT_LEVELS_LOADING:
    //   return {
    //     ...state,
    //     loading: action.payload,
    //   };

    default:
      return state;
  }
}